import { BaseSymbol } from '@ui/assets/config/trade-pair-listings';
import { AmountUsd } from '@ui/components/Amount/AmountUsd';
import { usePriceLive } from '@ui/hooks/price/usePriceLive';
import { useTokenDisplayDecimals } from '@ui/hooks/useTokenDisplayDecimals';
import { Position } from '@ui/services/contract/hooks/TradingReaderFacet/useGetPositionV2/types';
import { Nullable } from '@ui/types/utility';
import BigNumber from 'bignumber.js';
import { SystemStyleObject } from 'styled-system/types';

type MarketPriceProps = {
  position: Position;
  css: SystemStyleObject;
  marketPrice?: Nullable<BigNumber>;
  priceDisplayDecimals?: number;
};

export const MarketPrice = (props: MarketPriceProps) => {
  const { position, css, marketPrice, priceDisplayDecimals } = props;

  if (
    Object.prototype.hasOwnProperty.call(props, 'marketPrice') &&
    priceDisplayDecimals !== undefined
  ) {
    return (
      <MarketPriceValue
        css={css}
        marketPrice={marketPrice}
        priceDisplayDecimals={priceDisplayDecimals}
      />
    );
  }

  return (
    <MarketPriceWithHooks
      position={position}
      css={css}
      marketPrice={marketPrice}
    />
  );
};

const MarketPriceWithHooks = ({
  position,
  css,
  marketPrice: marketPriceProp,
}: {
  position: Position;
  css: SystemStyleObject;
  marketPrice?: Nullable<BigNumber>;
}) => {
  const marketPrice = usePriceLive(position.pair.baseSymbol);
  const priceDisplayDecimals = useTokenDisplayDecimals(
    position.pair.baseSymbol,
    position.pair.priceDisplayDecimals,
  );

  return (
    <MarketPriceValue
      css={css}
      marketPrice={marketPriceProp ?? marketPrice}
      priceDisplayDecimals={priceDisplayDecimals}
    />
  );
};

const MarketPriceValue = ({
  css,
  marketPrice,
  priceDisplayDecimals,
}: {
  css: SystemStyleObject;
  marketPrice?: Nullable<BigNumber>;
  priceDisplayDecimals: number;
}) => {
  return (
    <AmountUsd
      css={css}
      value={marketPrice ?? 0}
      opts={{
        displayDecimals: priceDisplayDecimals,
      }}
      data-cy="MarketPrice"
      data-cy-value={marketPrice ?? 0}
    />
  );
};
